import request from '@/utils/request';

export function collections4Lupe() {
  return request({
    url: '/lupe/collections',
    method: 'get'
  });
}
